<script setup>
import { onMounted } from 'vue'
import { useAlimentationStore } from '@/plugins/store/alimentation.ts'
import { Chart } from 'chart.js/auto'
// import { Chart, ChartConfiguration, LineController, LineElement, PointElement, LinearScale, Title} from 'chart.js'

const alimentation = useAlimentationStore()
alimentation.getHistoriqueAlimentation()


onMounted(() => {
  const alimentationCanvas = document.getElementById('alimentationCanvas')

  var data = [{
    'mai 2024': [10, 15, 12, 9, 7],
    'juin 2024': [13, 14, 12, 16, 17]
  }]
  new Chart(alimentationCanvas, {
    type: 'bar',
    data: {
      // labels: ["beijing", 'tokyo', 'seoul', 'hongkong'],
      datasets: data
      // datasets: [{
      //   data: [240, 120, 345, 890]
      // }]
    }
  })
})

</script>

<template>
  <v-card>
    <v-tabs>
      <v-tab v-for="itemAnnee in alimentation.listeAnnees" v-bind:key="itemAnnee" @click="alimentation.choixAnnee(itemAnnee)">
        {{ itemAnnee }}
      </v-tab>
    </v-tabs>
  </v-card>

  <v-card>
    <v-tabs>
      <v-tab v-for="itemMois in alimentation.listeMois" v-bind:key="itemMois" @click="alimentation.choixMois(itemMois)">
        {{ itemMois }}
      </v-tab>
    </v-tabs>
  </v-card>

  <div>
    <v-form v-model="alimentation.nouveauRepas.valid">
      <v-container>
        <v-row>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="alimentation.nouveauRepas.enfant"
              :counter="10"
              label="Prénom"
              hide-details
              required
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              type="datetime-local"
              v-model="alimentation.nouveauRepas.date"
              label="Date"
              required
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="1"
          >
            <v-checkbox
              v-model="alimentation.nouveauRepas.allaitement.sg"
              :counter="10"
              label="Sein gauche"
              hide-details
              required
            ></v-checkbox>
          </v-col>

          <v-col
            cols="12"
            md="1"
          >
            <v-checkbox
              v-model="alimentation.nouveauRepas.allaitement.sd"
              label="Sein droit"
              hide-details
              required
            ></v-checkbox>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="alimentation.nouveauRepas.lait.laitMaternel"
              label="LMT"
              hide-details
              required
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="alimentation.nouveauRepas.lait.laitPoudre"
              label="PRE"
              hide-details
              required
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="alimentation.nouveauRepas.lait.laitAnimal"
              label="Lait animal"
              hide-details
              required
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="alimentation.nouveauRepas.vomi"
              label="VOMI"
              hide-details
              required
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="2"
          >
            <v-btn
              :loading="loading"
              @click="alimentation.sauvegardeRepas()"
          >Sauvegarder</v-btn>
          </v-col>
        </v-row>

      </v-container>
    </v-form>
  </div>

  <canvas id="alimentationCanvas" aria-label="chart" role="img"></canvas>


  <div v-if="alimentation.selectionAnnee !== null && alimentation.selectionMois !== null" style="width: 100%; align-items: center; align-self: center; align-items: center;">
    <div v-for="jourObject, jour in alimentation.historique[alimentation.selectionAnnee][alimentation.selectionMois]" :key="jour-jourObject">

      <v-row>
        <v-col cols="12" md="1">
          <span>{{ jour }}</span>
        </v-col>
        <v-col cols="12" md="5">
          <v-table>
            <thead>
              <tr>
                <th class="text-center">
                  Heure
                </th>
                <th class="text-center">
                  Enfant
                </th>
                <th class="text-center">
                  SG
                </th>
                <th class="text-center">
                  SD
                </th>
                <th class="text-center">
                  LMT
                </th>
                <th class="text-center">
                  PRE
                </th>
                <th class="text-center">
                  VOMI
                </th>
                <th class="text-center">
                  SUPPRIMER
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in jourObject"
                :key="item.name"
              >
                <td>{{ item.date }}</td>
                <td>{{ item.enfant }}</td>
                <td>{{ item.sg === true ? "V" : "X" }}</td>
                <td>{{ item.sd === true ? "V" : "X" }}</td>
                <td>{{ item.lmt }}</td>
                <td>{{ item.pre }}</td>
                <td>{{ item.vomi }}</td>
                <td><v-btn large @click="alimentation.suppressionRepas(item.id)">SUPPRIMER</v-btn></td>
              </tr>
            </tbody>
          </v-table>
        </v-col>
        <v-col cols="12" md="6" class="div-graphiques">
        </v-col>
      </v-row>
    </div>
  </div>
</template>